import { logEvent } from "firebase/analytics";
import { analytics } from "../Context/firebaseConfig";

export const trackEvent = (eventName, params = {}) => {
  if (!analytics) return;

  try {
    logEvent(analytics, eventName, params);
  } catch { /* Analytics must never interrupt signup or the product. */ }
};